import { Component, inject, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LibPageHeaderComponent, LibWarrantyPolicyComponent } from '@web-nx-ng-tsc/web-promo-shared-ui';
import { IPageHeaderEntity, ITermsAndPolicyEntity } from '@web-nx-ng-tsc/web-shared-data-access';
import { IMeta, MetaService } from '@web-nx-ng-tsc/util-meta';
@Component({
  selector: 'app-five-year-warranty-policy',
  imports: [LibPageHeaderComponent, LibWarrantyPolicyComponent],
  templateUrl: './five-year-warranty-policy.component.html',
  styleUrl: './five-year-warranty-policy.component.scss',
})
export class FiveYearWarrantyPolicyComponent {
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly metaService = inject(MetaService);

  pageHeaderObj = signal<IPageHeaderEntity>({
    pageTitle: 'นโยบายการรับประกัน 5 ปี',
    subTitles: [
      {
        title: 'หน้าแรก',
        partName: '/',
      },
      {
        title: 'เกี่ยวกับเรา',
        partName: '/about-us/detail',
      },
      {
        title: 'นโยบายการรับประกัน 5 ปี',
        partName: '',
      },
    ],
  });

  innerContent = `
    <img class="warranty-image-layout" src="../../../../assets/images/img-tirewarranty-01.webp" alt="tirewarranty01" />
    <p>การชดเชยจะกระทําโดยการขายยางใหม่ให้กับร้านค้าราคาดังนี้</p>
    <img class="warranty-image-layout" src="../../../../assets/images/img-tirewarranty-02.webp" alt="tirewarranty02" />
    <div>
      <p>หมายเหตุ :</p>
      <p>
        (1) ราคายาง คือ ราคาขายที่บริษัทฯขายยางที่ขอการรับประกันให้กับร้านค้านั้นๆ
        <br />
        (2) ราคายางใหม่ คือ ราคาในใบราคา (Price List) ของบริษัทฯที่ไม่รวมรายการส่งเสริมการขาย
      </p>
  </div>
    `;

  warrantyPolicyObj: ITermsAndPolicyEntity[] = [
    {
      title:
        'บริษัท ต.สยาม คอมเมอร์เชียล จํากัด จะรับประกันคุณภาพผลิตภัณฑ์ยางรถยนต์ภายใต้ยี่ห้อ ADVANCE เฉพาะที่บริษัทฯนําเข้ามาจากต่างประเทศ ตามข้อกําหนดและเงื่อนไขที่ได้ระบุไว้ในนโยบายการรับประกันคุณภาพนี้เท่านั้น โดยไม่รวมถึงการรับประกันอื่นใดนอกเหนือจากนี้ เช่น ค่าบริการอันเกิดขึ้นจากการถอด ใส่ ค่าสูญเสียเวลา ค่าสูญเสียอันเนืองจากการไม่ได้ใช้รถยนต์ ค่าความไม่สะดวกและผลจากการเสียหายอื่นตามที่กฎหมายอนุญาต',
    },
    {
      title:
        'ผลิตภัณฑ์ยางรถยนต์ทุกเส้น จะได้รับการพิจารณาชดเชยต่อเมื่อได้รับการตรวจสอบเป็นที่แน่ชัดว่ายางชํารุดดังกล่าวมีสาเหตุจากผู้ผลิต เช่นเกิดจากข้อบกพร่องในการออกแบบ กรรมวิธีการผลิต และ/หรือ วัสดุที่ใช้ในการผลิตเป็นต้น',
    },
    {
      title:
        'การประเมินความชำรุดเสียหายของยางรถยนต์ว่าเกิดขึ้นเนื่องจากผู้ใช้หรือผู้ผลิต การตัดสินขั้นสุดท้ายจะกระทําโดยบุคคลที่ได้รับการแต่งตั้งจาก Advance Tyre (Vietnam) Co., Ltd ',
    },
    {
      title:
        'การชดเชย โดยบริษัทฯจะชดเชยยางยางเส้นใหม่ที่เป็นยางยี่ห้อ รุ่น และขนาดเดียวกันกับยางเดิมที่ชำรุด หากตรวจสอบได้ว่าการชำรุดเกิดจากคุณภาพผลิตภัณฑ์และความลึกร่องดอกยางที่เหลืออยู่มีค่ามากกว่า 2.5 มม. หมายเหตุ กรณีไม่มียางยี่ห้อ รุ่นและขนาดเดิม ทางบริษัทฯ จะชดเชยยางยี่ห้อ หรือ รุ่นอื่นทดแทน และหากยางใหม่ที่ชดเชยมีราคาสูงกว่า ผู้ขอรับประกันจะต้องชำระเงินส่วนต่างที่เกิดขึ้น โดยคิดคำนวณจากราคา ณ วันที่เปลี่ยนยาง',
    },
    {
      title: 'ยางชํารุดที่ได้รับการพิจารณาให้การชดเชย ให้ตกเป็นกรรมสิทธิ์ของ บริษัท ต.สยาม คอมเมอร์เชียล จํากัด',
    },
    {
      title:
        'ระยะเวลาการรับประกันคุณภาพผลิตภัณฑ์ฯ: 5 ปีนับแต่วัน เดือน ปี ที่ซื้อยาง โดยผู้ขอรับประกันจะต้องลงทะเบียนการรับประกันตามที่บริษัทฯกำหนดภายใน 15 วันนับแต่วันที่ระบุไว้ในใบเสร็จรับเงิน โดยระบุข้อมูลให้ครบถ้วนและถูกต้องตามความเป็นจริง มิฉะนั้นการรับประกันจะเป็นโมฆะและไม่มีผลบังคับใช้',
    },
    {
      title: 'ยางรถยนต์ที่มีลักษณะดังต่อไปนี้ จะไม่ได้รับการพิจารณาชดเชยและให้ถือว่าสิ้นสุดการรับประกัน ได้แก่',
      subtitle: [
        {
          headers:
            'ยางชำรุดที่เกิดจากการถูกของแหลมคมบาดและ/หรือตํา เช่น ตะปู แผ่นเหล็ก เศษแก้ว หรือยางชำรุดที่เกิดจากการกระแทกกับก้อนหิน ขอบถนน ขอบหลุม หรือวัตถุอื่นๆ',
        },
        {
          headers:
            'ยางชำรุดที่เกิดจากการใช้ลมยางไม่ถูกต้อง หรือใช้กระทะล้อไม่ถูกต้อง หรือเกิดจากการใช้งานในขณะที่ไม่มี แรงดันลมยาง',
        },
        {
          headers:
            'ยางสึกหรอผิดปกติ เนื่องจากการใช้แรงดันลมยางไม่ถูกต้อง ไม่มีการสลับตำแหน่งยาง การใช้กระทะล้อไม่ถูกต้อง ความบกพร่องของช่วงล่าง ศูนย์ล้อ โช้คอัพ ระบบเบรค รวมถึงการไม่สมดุลของล้อหรือความบกพร่องของชิ้นส่วนอื่นๆของรถยนต์',
        },
        {
          headers: 'ยางชำรุดเนื่องจาก การใส่ การถอดหรือการประกอบยางกับกระทะล้อไม่ถูกต้อง',
        },
        {
          headers: 'ยางที่เกิดปัญหาเต้นสั่น ภายหลังจากดอกยางสึกหรอไปแล้วมากกว่า 1มม.',
        },
        {
          headers: 'ยางที่ไม่ได้ซื้อขายผ่านผู้จัดจําหน่ายอย่างเป็นทางการจาก Advance Tyre (Vietnam) Co., Ltd ',
        },
        {
          headers: 'ยางที่ถูกนำไปใช้ ไม่ถูกต้องตามข้อกําหนด หรือใช้ในการแข่งขัน หรือรถที่ใช้งานพิเศษ',
        },
        {
          headers: 'ยางที่ถูกใช้งานจนความลึกของร่องดอกยางหลัก (Principal grooves) เหลือน้อยกว่า 2.5 มิลลิเมตร',
        },
        {
          headers: 'ยางที่มีการชำรุดเสียหายสืบเนืองมาจากการปะ – ซ่อม ',
        },
        {
          headers:
            'ยางที่เกิดอาการเสียงยางผิดปกติ อันเนื่องมาจากการสึกหรอผิดปกติของดอกยางหรือเสียงยางอันเนื่องมาจากความไม่พึงพอใจของลูกค้า',
        },
        {
          headers:
            ' ยางรถยนต์ภายใต้ยี่ห้อADVANCE ที่เป็นยางติดรถใหม่ (Original Equipment) และ/ หรือ เป็นยางนำเข้ามา จากต่างประเทศโดยผู้นำเข้ารายอื่นๆที่มิใช่บริษัท ต.สยาม คอมเมอร์เชียล จำกัด จะไม่ได้รับการรับประกันฯ  ตามนโยบายฉบับนี้',
        },
        {
          headers:
            'ยางที่ไม่ได้ลงทะเบียนรับสิทธิประโยชน์การรับประกันยางรถยนต์ชำรุด รวมถึงกรณีเอกสารหลักฐานการรับประกันชำรุดหรือสูญหาย ',
        },
        {
          headers: 'ความไม่พึงพอใจในสินค้า เช่น เสียงของยาง ความแข็งกระด้างหรือนุ่มนวลของยาง	',
        },
        {
          headers: 'ยางที่ถูกดัดแปลงแก้ไขหมายเลขยาง (Tire DOT serial or Tire Serial Number)',
        },
      ],
    },
    {
      title:
        'ร้านค้าหรือลูกค้า จะเป็นผู้ออกค่าใช้จ่ายในการขนส่งยางจากร้านค้ามายังบริษัทฯเพื่อขอให้บริษัทฯพิจารณาชดเชย โดยบริษัทฯจะไม่รับผิดชอบต่อการสูญหาย หรือความเสียหายใดๆในระหว่างการขนส่ง',
    },
    {
      title: 'ร้านค้าหรือลูกค้า จะเป็นผู้ออกค่าใช้จ่ายในการขนส่งยางที่ไม่ได้รับการพิจารณาชดเชยกลับคืนให้ลูกค้า',
    },
    {
      title:
        'ทางบริษัทฯ จะดำเนินการตามกฎหมายหากทำการตรวจสอบและพบว่าผู้ขอการรับประกัน และ/หรือร้านค้า และ/หรือ ตัวแทนจำหน่าย ได้ทำการทุจริตเพื่อให้ทางบริษัทฯ เกิดความเสียหายจากนโยบายการรับประกันดังกล่าว',
    },
    {
      title:
        'บริษัท ต.สยาม คอมเมอร์เชียล จํากัด ขอสงวนสิทธิ์ในการยกเลิก และ/หรือ แก้ไขเปลี่ยนแปลงนโยบายการรับประกันคุณภาพฯนี้ ทั้งหมดหรือส่วนหนึ่งส่วนใด เพื่อความเหมาะสม โดยไม่จําเป็นต้องแจ้งให้ทราบล่วงหน้า',
    },
  ];

  constructor() {
    this.metaService.updateMeta(this.route.snapshot.data as IMeta);
    this.onSetOpenGraphTags();
  }

  redirectTo(url: string) {
    this.router.navigate([`${url}`]);
  }

  onSetOpenGraphTags() {
    this.metaService.updateOpenGraph({
      title: 'นโยบายรับประกันยาง | ADVANCE TYRE Thailand',
      description:
        'อ่านนโยบายรับประกันยางของ ADVANCE TYRE แบบครบถ้วน ครอบคลุมระยะคุ้มครอง เงื่อนไข ข้อยกเว้น เอกสารที่ต้องใช้ และขั้นตอนการยื่นเคลมอย่างถูกต้อง ติดต่อทีมงานเพื่อคำแนะนำเฉพาะเคสได้สะดวก ช่วยให้ใช้สิทธิ์ได้เต็มที่และดำเนินการรวดเร็ว มั่นใจทุกการซื้อยาง',
      image: 'https://tsc-pub-blob.s3.ap-southeast-7.amazonaws.com/2025-08/logo.webp',
    });
  }
}
